import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref } from "vue"
import { PlantDetail } from "@/models/plant/plant.detail"
import { emptyImageItem, ImageItem } from "@/models/images/image.item"
import ImageViewPopup from "@/components/plant/ImageViewPopup.vue"
import imageRepository from "@/services/ImageRepository"
import { useConfirm } from "primevue/useconfirm"
import { useAuthStore } from "@/store/auth"
import useNotification from "@/logics/useNotification"
import Repository from "@/services/Repository"


const __default__ = {
  name: "ImageViewList"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  plant: {
    type: Object as PropType<PlantDetail>,
    required: true
  }
},
  setup(__props, { expose }) {
  expose();

const props = __props

const MAX_IMAGE_FILE_SIZE = 2 * 1048 * 1048



const image = ref({...emptyImageItem})
const displayPopup = ref(false)
const loading = ref(false)

const confirm = useConfirm()
const notification = useNotification()

const plantImages = ref([...props.plant?.images ?? []])

const displayImages = computed(() => [...plantImages.value, {
  ...emptyImageItem
}])

const getImageUrl = (id: string) => {
  return `/api/v1/images/${id}`
}

const showImage = (selectedImage: ImageItem) => {
  image.value = {
    ...emptyImageItem,
    ...selectedImage
  }
  displayPopup.value = true
}

const authStore = useAuthStore()

const sendHeader = (request) => {
  request.xhr.setRequestHeader('Content-Type', 'application/json')
  request.xhr.setRequestHeader('Authorization', `Bearer ${authStore.token}`)
  return request
}

const toBase64 = file => new Promise<string>((resolve, reject) => {
  const reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = () => resolve(reader.result as string)
  reader.onerror = error => reject(error)
})


const selectImage = async (event) => {
  if (event.files[0].size > MAX_IMAGE_FILE_SIZE) {
    notification.showError('File ảnh quá lớn. Yêu cầu file ảnh có dung lượng dưới 2Mb')
    return
  }
  const imageContent = await toBase64(event.files[0])
  const plantId = props.plant?.id ?? ''
  const response = await imageRepository.create({
    plantId,
    imageContent
  })

  plantImages.value = [...plantImages.value, response.data]
  notification.showMessage('Đã thêm ảnh thành công')
}

const saveImage = async () => {
  try {
    loading.value = true
    const _image = image.value
    await imageRepository.update(_image.id, _image)
    plantImages.value = plantImages.value.map(x => x.id == _image.id ? {..._image} : x)
  } finally {
    loading.value = false
  }
}

const deleteImage = async () => {
  confirm.require({
    message: 'Chắc chắn muốn xoá hình ảnh này?',
    header: 'Xác nhận',
    icon: 'pi pi-exclamation-triangle',
    accept: async () => {
      try {
        loading.value = true
        await imageRepository.delete(image.value.id)
        plantImages.value = plantImages.value.filter(x => x.id !== image.value.id)
      } finally {
        loading.value = false
      }
    },
  })
}

const __returned__ = { MAX_IMAGE_FILE_SIZE, props, image, displayPopup, loading, confirm, notification, plantImages, displayImages, getImageUrl, showImage, authStore, sendHeader, toBase64, selectImage, saveImage, deleteImage, ImageViewPopup }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})